import { ELEVATIONS, type SourceKey } from "./evidence";

export const MOUNTAIN_COMPARISONS = [
  {
    id: "north-alps",
    name: "Northern French Alps",
    elevation: ELEVATIONS[0],
    guide: "alps",
    place: "morzine",
    interpretation:
      "Higher terrain retains an advantage, but low return runs and valley links can still be exposed.",
    source: "elevation",
  },
  {
    id: "south-alps",
    name: "Southern French Alps",
    elevation: ELEVATIONS[1],
    guide: "alps",
    place: null,
    interpretation:
      "The same natural-snow criterion is reached higher here than in the northern French Alps.",
    source: "elevation",
  },
  {
    id: "french-pyrenees",
    name: "French Pyrenees",
    elevation: ELEVATIONS[2],
    guide: "pyrenees",
    place: null,
    interpretation:
      "The model points to pressure on lower terrain; altitude, aspect and management all affect individual slopes.",
    source: "elevation",
  },
  {
    id: "south-pyrenees",
    name: "Spanish / Andorran Pyrenees",
    elevation: ELEVATIONS[3],
    guide: "pyrenees",
    place: null,
    interpretation:
      "Higher reliability elevations can leave less terrain meeting the criterion. This is not a forecast of resort closures.",
    source: "elevation",
  },
] as const;

export const COAST_COMPARISONS: readonly {
  id: string;
  name: string;
  direction: "increase" | "decrease";
  places: string;
  interpretation: string;
  source: SourceKey;
}[] = [
  {
    id: "atlantic",
    name: "North Atlantic",
    direction: "decrease",
    places: "Regional context for Hossegor and Newquay",
    interpretation:
      "A fall in average offshore wave height can alter swell supply. Storms, local winds and moving sandbanks still shape each session.",
    source: "waveRegions",
  },
  {
    id: "southern",
    name: "Southern Ocean",
    direction: "increase",
    places: "Swell source for exposed southern coasts",
    interpretation:
      "Increasing offshore waves can change swell reaching distant coasts. Break orientation and the swell's path determine local exposure.",
    source: "waveRegions",
  },
  {
    id: "east-pacific",
    name: "Tropical eastern Pacific",
    direction: "increase",
    places: "Regional offshore projection",
    interpretation:
      "More mean offshore wave height does not establish more rideable days. Reef shape, water depth and local wind still matter.",
    source: "waveRegions",
  },
  {
    id: "mediterranean",
    name: "Mediterranean",
    direction: "decrease",
    places: "Regional offshore projection",
    interpretation:
      "Lower average wave heights can coexist with coastal flooding and damaging storms. Sea-level rise adds a separate pressure.",
    source: "waveRegions",
  },
];

export function compareElevation(elevation: number, low: number, high: number) {
  if (elevation < low) return "below";
  if (elevation > high) return "above";
  return "within";
}

/** Resolve duplicate externally supplied selections without hiding a comparison column. */
export function distinctComparisons(
  ids: readonly string[],
  available: readonly string[],
): string[] {
  const result: string[] = [];
  for (const id of ids) {
    const choice =
      available.includes(id) && !result.includes(id)
        ? id
        : available.find((entry) => !result.includes(entry));
    if (choice) result.push(choice);
  }
  return result;
}
